export default __webpack_public_path__ + "static/media/WEBSITE FACE.ece806ff.webp";